import React, { memo, useEffect, useRef } from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    className?: string,
    title?: string,
    colour: string,
    isCurrent: boolean,
    isLast: boolean,
    isWatched: boolean,
    onClickHandler: () => void,
};

const VideoCatalogItem: React.FC<Props> = ({
    className = "",
    title = "",
    colour,
    isCurrent,
    isLast,
    isWatched,
    onClickHandler,
}) => {
    const theme = useTheme();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isCurrent && ref.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest",
            });
        }
    }, [isCurrent]);

    const style = css`
        display: flex;
        flex-direction: row;
    `;

    const iconContainerStyle = css`
        width: 24px;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `;

    const iconStyle = (colour: string, isCurrent: boolean, isDone: boolean) => css`
        min-width: 24px;
        min-height: 24px;
        color: ${colour};
        border: 2px solid ${isDone ? colour : theme.colours.silver3};
        border-radius: 50%;
        background-color: ${isDone ? colour : theme.colours.white};
        position: relative;

        ${isCurrent && css`
            background-color: ${theme.colours.white};
            font-weight: ${theme.fonts.weights.bold};

            :after {
                content: '';
                min-width: 10px;
                min-height: 10px;
                border-radius: 50%;
                background-color: ${colour};
                position: absolute;
                left: 5px;
                top: 5px;
            }
        `};
    `;

    const lineStyle = (colour: string, isDone: boolean, isLast: boolean) => css`
        width: 2px;
        height: 100%;
        background-color: ${isDone ? colour : theme.colours.silver3};

        ${isLast && css`
            background-color: ${theme.colours.white};
        `};
    `;

    const descriptionStyle = css`
        width: 100%;
        height: 100%;
        word-break: break-word;
        padding-left: 8px;
        margin-bottom: 38px;

        cursor: pointer;
    `;

    const itemTitleStyle = (isCurrent: boolean) => css`
        font-size: 18px;
        line-height: 22px;
        word-break: break-word;
        font-weight: ${isCurrent ? theme.fonts.weights.bold : theme.fonts.weights.normal};
        transition: text-decoration ${theme.transitions.transitionFaster};

        &:hover {
            text-decoration: underline;
        }
    `;

    return (
        <div css={style} className={className} ref={ref}>
            <div css={iconContainerStyle}>
                <div css={iconStyle(colour, isCurrent, isWatched)} />
                <div css={lineStyle(colour, isWatched, isLast)} />
            </div>
            <div css={descriptionStyle} onClick={onClickHandler}>
                <div css={itemTitleStyle(isCurrent)}>{title} it maximum two line title</div>
            </div>
        </div>
    );
};

export default memo(VideoCatalogItem);